import langslabs from '@/apps/slabs/lang/';
export default {
    langslabs: langslabs,
	token_slabs: localStorage.getItem('access_token_slabs') || null,
    slabs: false,
    slabsStorage:[],
}
